import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import {
  FaUsers,
  FaHistory,
  FaBullseye,
  FaCogs,
  FaHandshake,
} from "react-icons/fa";
import "./../styles/about.css";

const About = () => {
  const sections = [
    {
      icon: <FaUsers size={36} />,
      title: "QUI SOMMES NOUS",
      description:
        "Chez SARL AGORA GLOBAL, nous sommes passionnés par l'informatique et la technologie. Depuis notre fondation, nous nous sommes engagés à fournir des solutions informatiques innovantes et personnalisées à nos clients.",
      details:
        "Notre équipe diversifiée apporte une richesse d'expérience et de perspectives, permettant d'offrir des solutions vraiment innovantes.",
    },
    {
      icon: <FaHistory size={36} />,
      title: "NOTRE HISTOIRE",
      description:
        "SARL AGORA GLOBAL est avant tout, une équipe de consultants indépendants depuis plusieurs années, nous avons évolué pour devenir un acteur majeur de l'industrie informatique.",
      details:
        "De nos humbles débuts à notre position actuelle de leader, chaque étape de notre parcours a été marquée par l'innovation et l'excellence.",
    },
    {
      icon: <FaBullseye size={36} />,
      title: "NOTRE MISSION",
      description:
        "Notre mission est de simplifier la complexité de la technologie et de la rendre accessible à tous. Nous sommes là pour vous accompagner.",
      details:
        "Nous croyons que la technologie devrait être un facilitateur, pas un obstacle. Notre approche est centrée sur la simplicité et l'efficacité.",
    },
    {
      icon: <FaCogs size={36} />,
      title: "NOTRE EXPERTISE",
      description:
        "Notre équipe d'experts chevronnés est composée de passionnés de l'informatique, de développeurs talentueux et de professionnels du support technique.",
      details:
        "De la conception à l'implémentation, notre expertise technique nous permet de relever les défis les plus complexes.",
    },
    {
      icon: <FaHandshake size={36} />,
      title: "NOS VALEURS",
      description:
        "L'intégrité, l'innovation et le service client sont les piliers de notre entreprise. Nous croyons en des relations solides et durables avec nos clients.",
      details:
        "Nos valeurs ne sont pas de simples mots - elles guident chaque décision et interaction que nous avons.",
    },
  ];

  return (
    <div className="about-page">
      {/* Subtle background effect */}
      <div className="background-effect">
        <div className="gradient-circle circle-1"></div>
        <div className="gradient-circle circle-2"></div>
        <div className="gradient-circle circle-3"></div>
      </div>

      {/* Hero Section */}
      <section className="pt-5">
        <Container>
               <h1 className="hero-title justify-content-center"> <InfoCircle className="title-icon" /> À PROPOS DE NOUS</h1>
          <Row className="justify-content-center text-center">
            <Col lg={8} md={10}>
              <div className="title-underline"></div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Main Content */}
      <section className="content-section">
        <Container>
          <Row>
            {sections.map((section, index) => (
              <Col key={index} lg={6} className="mb-4">
                <div className={`content-card card-${index}`}>
                  <div className="card-icon">{section.icon}</div>
                  <div className="card-content">
                    <h3 className="card-title">{section.title}</h3>
                    <p className="card-description">{section.description}</p>
                    <p className="card-details">{section.details}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default About;